

// Generated class BookingDayTimeRange_ManagedObject

class BookingDayTimeRange_ManagedObject extends MIOManagedObject
{

    // Property: identifier
    set identifier(value:string) {
        this.setValueForKey(value, 'identifier');
    }
    get identifier():string {
        return this.valueForKey('identifier');
    }
    set identifierPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'identifier');
    }
    get identifierPrimitiveValue():string {
        return this.primitiveValueForKey('identifier');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: time
    set time(value:string) {
        this.setValueForKey(value, 'time');
    }
    get time():string {
        return this.valueForKey('time');
    }
    set timePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'time');
    }
    get timePrimitiveValue():string {
        return this.primitiveValueForKey('time');
    }

    // Property: group
    set group(value:string) {
        this.setValueForKey(value, 'group');
    }
    get group():string {
        return this.valueForKey('group');
    }
    set groupPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'group');
    }
    get groupPrimitiveValue():string {
        return this.primitiveValueForKey('group');
    }

    // Property: nextDay
    set nextDay(value:boolean) {
        this.setValueForKey(value, 'nextDay');
    }
    get nextDay():boolean {
        return this.valueForKey('nextDay');
    }
    set nextDayPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'nextDay');
    }
    get nextDayPrimitiveValue():boolean {
        return this.primitiveValueForKey('nextDay');
    }

    // Property: showRange
    set showRange(value:boolean) {
        this.setValueForKey(value, 'showRange');
    }
    get showRange():boolean {
        return this.valueForKey('showRange');
    }
    set showRangePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'showRange');
    }
    get showRangePrimitiveValue():boolean {
        return this.primitiveValueForKey('showRange');
    }

    // Property: createdAt
    set createdAt(value:Date) {
        this.setValueForKey(value, 'createdAt');
    }
    get createdAt():Date {
        return this.valueForKey('createdAt');
    }
    set createdAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'createdAt');
    }
    get createdAtPrimitiveValue():Date {
        return this.primitiveValueForKey('createdAt');
    }

    // Property: updatedAt
    set updatedAt(value:Date) {
        this.setValueForKey(value, 'updatedAt');
    }
    get updatedAt():Date {
        return this.valueForKey('updatedAt');
    }
    set updatedAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'updatedAt');
    }
    get updatedAtPrimitiveValue():Date {
        return this.primitiveValueForKey('updatedAt');
    }

    // Property: deletedAt
    set deletedAt(value:Date) {
        this.setValueForKey(value, 'deletedAt');
    }
    get deletedAt():Date {
        return this.valueForKey('deletedAt');
    }
    set deletedAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'deletedAt');
    }
    get deletedAtPrimitiveValue():Date {
        return this.primitiveValueForKey('deletedAt');
    }
}
